import {
  getActivityLogs,
  getStickerTransactions,
  getStripeTransactions,
  getBenevityTransactions,
  getBenevityW2WCreditTransactions,
} from '@/graphs/activity';
import globalShared from '@/shared';

const { makeGraphRequest, getAuthToken } = globalShared();

const actions = {
  SET_SORT({ commit }, value) {
    commit('MUTATE_SORT', value);
  },
  SET_DATE({ commit }, value) {
    commit('MUTATE_DATE', value);
  },
  SET_SEARCH({ commit }, value) {
    commit('MUTATE_SEARCH', value);
  },
  SET_CURRENT_TAB({ commit, dispatch }, value) {
    commit('MUTATE_CURRENT_TAB', value);
    // Reset pagination when changing tabs
    commit('MUTATE_PAGINATION', { skip: 0, take: 8 });
    // Fetch data for the new tab
    dispatch('FETCH_CURRENT_TAB_DATA');
  },
  SET_PAGINATION({ commit, dispatch }, value) {
    commit('MUTATE_PAGINATION', value);
    dispatch('FETCH_CURRENT_TAB_DATA');
  },
  async FETCH_ACTIVITY_LOGS({ commit, getters, rootGetters }, { entity = '', entityId = '' }) {
    commit('MUTATE_ACTIVITY_LOGS_LOADING', true);
    commit('MUTATE_ACTIVITY_LOGS_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
    };

    try {
      const response = await makeGraphRequest('query', getActivityLogs, variables, token);
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_ACTIVITY_LOGS', response.data.GetPaymentsLogsForActivity);
      commit('MUTATE_ACTIVITY_LOGS_LOADING', false);
      commit('MUTATE_ACTIVITY_LOGS_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_ACTIVITY_LOGS_ERROR', e);
      commit('MUTATE_ACTIVITY_LOGS_LOADING', false);
      return false;
    }
  },

  async FETCH_STICKER_TRANSACTIONS({ commit, getters, rootGetters }, {
    entity = null, entityId = null, skip = null, take = null,
  }) {
    commit('MUTATE_STICKER_LOADING', true);
    commit('MUTATE_STICKER_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      skip,
      take,
    };

    try {
      const response = await makeGraphRequest('query', getStickerTransactions, variables, token);
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_STICKER_TRANSACTIONS', response.data.GetStickerTransactionsForActivity);
      commit('MUTATE_STICKER_LOADING', false);
      commit('MUTATE_STICKER_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_STICKER_ERROR', e);
      commit('MUTATE_STICKER_LOADING', false);
      return false;
    }
  },

  async FETCH_STRIPE_TRANSACTIONS({ commit, getters, rootGetters }, {
    entity = null, entityId = null, skip = null, take = null,
  }) {
    commit('MUTATE_STRIPE_LOADING', true);
    commit('MUTATE_STRIPE_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      skip,
      take,
    };

    try {
      const response = await makeGraphRequest('query', getStripeTransactions, variables, token);
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_STRIPE_TRANSACTIONS', response.data.GetStripeTransactionsForActivity);
      commit('MUTATE_STRIPE_LOADING', false);
      commit('MUTATE_STRIPE_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_STRIPE_ERROR', e);
      commit('MUTATE_STRIPE_LOADING', false);
      return false;
    }
  },

  async FETCH_BENEVITY_TRANSACTIONS({ commit, getters, rootGetters }, {
    entity = null, entityId = null, skip = null, take = null,
  }) {
    commit('MUTATE_BENEVITY_LOADING', true);
    commit('MUTATE_BENEVITY_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      skip,
      take,
    };

    try {
      const response = await makeGraphRequest('query', getBenevityTransactions, variables, token);
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_BENEVITY_TRANSACTIONS', response.data.GetBenevityTransactionsForActivity);
      commit('MUTATE_BENEVITY_LOADING', false);
      commit('MUTATE_BENEVITY_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_BENEVITY_ERROR', e);
      commit('MUTATE_BENEVITY_LOADING', false);
      return false;
    }
  },

  async FETCH_BENEVITY_W2W_TRANSACTIONS({ commit, getters, rootGetters }, {
    entity = null, entityId = null, skip = null, take = null,
  }) {
    commit('MUTATE_BENEVITY_W2W_LOADING', true);
    commit('MUTATE_BENEVITY_W2W_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      skip,
      take,
    };

    try {
      const response = await makeGraphRequest('query', getBenevityW2WCreditTransactions, variables, token);
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_BENEVITY_W2W_TRANSACTIONS', response.data.GetBenevityW2WCreditTransactionsForActivity);
      commit('MUTATE_BENEVITY_W2W_LOADING', false);
      commit('MUTATE_BENEVITY_W2W_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_BENEVITY_W2W_ERROR', e);
      commit('MUTATE_BENEVITY_W2W_LOADING', false);
      return false;
    }
  },

  async FETCH_CURRENT_TAB_DATA({ dispatch, getters, rootGetters }) {
    const currentTab = getters.GET_CURRENT_TAB;
    const pagination = getters.GET_PAGINATION;
    const isOrgAdmin = rootGetters['users/isOrgAdmin'];

    let entity = null;
    let entityId = null;

    if (isOrgAdmin) {
      const selectedOrg = rootGetters['organizations/GET_SELECTED_ORGANIZATION'];
      if (selectedOrg && selectedOrg.id) {
        entity = 'Organization';
        entityId = selectedOrg.id;
      }
    }

    const params = {
      entity,
      entityId,
      skip: pagination.skip,
      take: pagination.take,
    };

    switch (currentTab) {
      case 'sticker':
        return await dispatch('FETCH_STICKER_TRANSACTIONS', params);
      case 'stripe':
        return await dispatch('FETCH_STRIPE_TRANSACTIONS', params);
      case 'benevity':
        return await dispatch('FETCH_BENEVITY_TRANSACTIONS', params);
      case 'benevity-w2w':
        return await dispatch('FETCH_BENEVITY_W2W_TRANSACTIONS', params);
      default:
        return await dispatch('FETCH_STICKER_TRANSACTIONS', params);
    }
  },

  async SET_SELECTED_LOGS({ commit }, value) {
    commit('MUTATE_SELECTED_LOGS', value);
  },
};

export default actions;
